import { Component, ElementRef, Inject } from '@angular/core';
import * as utils from '../utils';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ColorEvent } from 'ngx-color';
import { dialogType } from '@core_n/enums';

const COLORS = [
  '#000000', '#804000', '#FE0000', '#FE6A00', '#FFD800', '#00FF01',
  '#545454', '#401F00', '#800001', '#803400', '#806B00', '#017F01',
  '#A8A8A8', '#01FFFF', '#0094FE', '#0026FF', '#B100FE', '#FF006E',
  '#FFFFFF', '#017F7E', '#00497E', '#001280', '#590080', '#7F0037',
];

@Component({
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {

  readonly colors = COLORS;
  selectedColor: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: any, public matDialogRef: MatDialogRef<ColorPickerComponent>) {
    if (data && data.color) {
      this.selectedColor = data.color;
    }

    matDialogRef.beforeClosed().subscribe(() => matDialogRef.close(this.selectedColor));
  }

  

  static defaultColor(): string {
    return COLORS[0];
  }

  colorChanged($event: ColorEvent)
  {
    this.selectedColor = $event.color.hex;
  }

  static createDialogConfig(relativeToElement: ElementRef, selectedColor?: string) {
    let rect = relativeToElement.nativeElement.getBoundingClientRect();
    let position = { top: `${rect.top - rect.height}px`, left: `${rect.left + rect.width/2}px` };

    let dialogConfig = utils.createDialogConfig(false, true, dialogType.colorPicker, position);

    if (selectedColor)
      dialogConfig.data = { color: selectedColor };
    dialogConfig.maxWidth = 250;
    dialogConfig.maxHeight = 350;
    return dialogConfig;
  }
  
}
